import { Constants } from "../constants";
export const helperDataFormService = {

	/**
	 *
	 * @param type
	 * @param jsonFromServer
	 * @description
	 * the data model from server is quite different from the data model present on
	 * this form. This method exists to adjust this differences.
	 */
	preAdjustsJsonFromServer(type, jsonFromServer) {
		try {


			// setup common to perso and orga :

			// add missing 'consentement' key
			jsonFromServer.consentement = {};
			jsonFromServer.consentement.admissible = true;
			jsonFromServer.consentement.information = true;
			jsonFromServer.consentement.demandeIsni = true;

			// renaming NomPrincipalOrganisme at relation
			if (
				jsonFromServer.relation &&
				jsonFromServer.relation.idOrganisme0 &&
				jsonFromServer.relation.idOrganisme0.NomPrincipalOrganisme
			) {
				jsonFromServer.relation.idOrganisme0.nomOrganisme = jsonFromServer.relation.idOrganisme0.NomPrincipalOrganisme;
				delete jsonFromServer.relation.idOrganisme0.NomPrincipalOrganisme;
			}
			if (
				jsonFromServer.relation &&
				jsonFromServer.relation.idOrganisme1 &&
				jsonFromServer.relation.idOrganisme1.NomPrincipalOrganisme
			) {
				jsonFromServer.relation.idOrganisme1.nomOrganisme =
					jsonFromServer.relation.idOrganisme1.NomPrincipalOrganisme;
				delete jsonFromServer.relation.idOrganisme1.NomPrincipalOrganisme;
			}
			if (
				jsonFromServer.relation &&
				jsonFromServer.relation.idOrganisme2 &&
				jsonFromServer.relation.idOrganisme2.NomPrincipalOrganisme
			) {
				jsonFromServer.relation.idOrganisme2.nomOrganisme =
					jsonFromServer.relation.idOrganisme2.NomPrincipalOrganisme;
				delete jsonFromServer.relation.idOrganisme2.NomPrincipalOrganisme;
			}

			// adjusting incorrect position of the keys
			// Moving nomAssocie
			if (jsonFromServer.nomAssocie) {
				if (!jsonFromServer.donneeIdentification) {
					jsonFromServer.donneeIdentification = {};
				}
				jsonFromServer.donneeIdentification.nomAssocie = jsonFromServer.nomAssocie;
				delete jsonFromServer.nomAssocie;
			}
			// Moving variante
			if (jsonFromServer.variante) {
				if (!jsonFromServer.donneeIdentification) {
					jsonFromServer.donneeIdentification = {};
				}
				jsonFromServer.donneeIdentification.variante = jsonFromServer.variante;
				delete jsonFromServer.variante;
			}



			// adjusting specific keys for perso :

			if (type === Constants.TYPE_FORM.perso) {
				// adjusting date
				// adjusting 'mois'
				if (
					jsonFromServer.donneeIdentification.date.naissance.mois !== '' &&
					jsonFromServer.donneeIdentification.date.naissance.mois.indexOf('_') === -1
				) {
					jsonFromServer.donneeIdentification.date.naissance.mois =
						'_' + jsonFromServer.donneeIdentification.date.naissance.mois;
				}
				if (
					jsonFromServer.donneeIdentification.date.deces.mois !== '' &&
					jsonFromServer.donneeIdentification.date.deces.mois.indexOf('_') === -1
				) {
					jsonFromServer.donneeIdentification.date.deces.mois =
						'_' + jsonFromServer.donneeIdentification.date.deces.mois;
				}
				// adjusting 'jour'
				if (jsonFromServer.donneeIdentification.date.naissance.jour !== '') {
					jsonFromServer.donneeIdentification.date.naissance.jour =
						parseInt(jsonFromServer.donneeIdentification.date.naissance.jour, 10);
				}
				if (jsonFromServer.donneeIdentification.date.deces.jour !== '') {
					jsonFromServer.donneeIdentification.date.deces.jour =
						parseInt(jsonFromServer.donneeIdentification.date.deces.jour, 10);
				}

				return true;
			}


			// adjusting specific keys for orga :

			if (type === Constants.TYPE_FORM.orga) {
				// adjusting date
				// adjusting 'mois'
				if (
					jsonFromServer.donneeIdentification.date.debutUtilisationNom.mois !== '' &&
					jsonFromServer.donneeIdentification.date.debutUtilisationNom.mois.indexOf('_') === -1
				) {
					jsonFromServer.donneeIdentification.date.debutUtilisationNom.mois =
						'_' + jsonFromServer.donneeIdentification.date.debutUtilisationNom.mois;
				}
				if (
					jsonFromServer.donneeIdentification.date.finUtilisationNom.mois !== '' &&
					jsonFromServer.donneeIdentification.date.finUtilisationNom.mois.indexOf('_') === -1
				) {
					jsonFromServer.donneeIdentification.date.finUtilisationNom.mois =
						'_' + jsonFromServer.donneeIdentification.date.finUtilisationNom.mois;
				}
				// adjusting 'jour'
				if (jsonFromServer.donneeIdentification.date.debutUtilisationNom.jour !== '') {
					jsonFromServer.donneeIdentification.date.debutUtilisationNom.jour =
						parseInt(jsonFromServer.donneeIdentification.date.debutUtilisationNom.jour, 10);
				}
				if (jsonFromServer.donneeIdentification.date.finUtilisationNom.jour !== '') {
					jsonFromServer.donneeIdentification.date.finUtilisationNom.jour =
						parseInt(jsonFromServer.donneeIdentification.date.finUtilisationNom.jour, 10);
				}

				return true;
			}

			return true;

		} catch(e) {
			console.debug('[helperDataFormService - preAdjustsJsonFromServer] Exception: %o', e);
			return false;
		}

	},
	/**
	 *
	 * @param type
	 * @param dataForm
	 * @description
	 * Setup initial value to the fields not official to the form (checks fields. etc)
	 */
	setupHelperDataForm(type, dataForm) {
		// setup common to perso and orga :

		// check and adjust nomAssocie (0 to 2)
		dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept0.check =
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept0.associeNom != '' ||
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept0.associeNomType != '';
		dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept1.check =
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept1.associeNom != '' ||
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept1.associeNomType != '';
		dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept2.check =
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept2.associeNom != '' ||
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept2.associeNomType != '';

		// check and clean variante (0 to 4)
		dataForm.donneeIdentification.variante.idVariante0.check =
			dataForm.donneeIdentification.variante.idVariante0.nom != '' ||
			dataForm.donneeIdentification.variante.idVariante0.prenom != '';
		dataForm.donneeIdentification.variante.idVariante1.check =
			dataForm.donneeIdentification.variante.idVariante1.nom != '' ||
			dataForm.donneeIdentification.variante.idVariante1.prenom != '';
		dataForm.donneeIdentification.variante.idVariante2.check =
			dataForm.donneeIdentification.variante.idVariante2.nom != '' ||
			dataForm.donneeIdentification.variante.idVariante2.prenom != '';
		dataForm.donneeIdentification.variante.idVariante3.check =
			dataForm.donneeIdentification.variante.idVariante3.nom != '' ||
			dataForm.donneeIdentification.variante.idVariante3.prenom != '';
		dataForm.donneeIdentification.variante.idVariante4.check =
			dataForm.donneeIdentification.variante.idVariante4.nom != '' ||
			dataForm.donneeIdentification.variante.idVariante4.prenom != '';

		// check and clean oeuvre (0 to 3)
		dataForm.oeuvre.idOeuvre1.ajoutCheck =
			dataForm.oeuvre.idOeuvre1.roleOeuvre != '' ||
			dataForm.oeuvre.idOeuvre1.sousTitreOeuvre != '' ||
			dataForm.oeuvre.idOeuvre1.thematiqueOeuvre != '' ||
			dataForm.oeuvre.idOeuvre1.titreOeuvre != '' ||
			dataForm.oeuvre.idOeuvre1.typeOeuvre != '';
		dataForm.oeuvre.idOeuvre2.ajoutCheck =
			dataForm.oeuvre.idOeuvre2.roleOeuvre != '' ||
			dataForm.oeuvre.idOeuvre2.sousTitreOeuvre != '' ||
			dataForm.oeuvre.idOeuvre2.thematiqueOeuvre != '' ||
			dataForm.oeuvre.idOeuvre2.titreOeuvre != '' ||
			dataForm.oeuvre.idOeuvre2.typeOeuvre != '';
		dataForm.oeuvre.idOeuvre3.ajoutCheck =
			dataForm.oeuvre.idOeuvre3.roleOeuvre != '' ||
			dataForm.oeuvre.idOeuvre3.sousTitreOeuvre != '' ||
			dataForm.oeuvre.idOeuvre3.thematiqueOeuvre != '' ||
			dataForm.oeuvre.idOeuvre3.titreOeuvre != '' ||
			dataForm.oeuvre.idOeuvre3.typeOeuvre != '';

		// check and clean relation (0 to 2 Personne, 0 to 2 Organisme)
		dataForm.relation.relationProCheck =
			dataForm.relation.idPersonne0.typeRelation != '' ||
			dataForm.relation.idPersonne0.nom != '' ||
			dataForm.relation.idPersonne0.prenom != '' ||
			dataForm.relation.idPersonne1.typeRelation != '' ||
			dataForm.relation.idPersonne1.nom != '' ||
			dataForm.relation.idPersonne1.prenom != '' ||
			dataForm.relation.idPersonne2.typeRelation != '' ||
			dataForm.relation.idPersonne2.nom != '' ||
			dataForm.relation.idPersonne2.prenom != '';
		dataForm.relation.idPersonne1.relationProCheck =
			dataForm.relation.idPersonne1.typeRelation != '' ||
			dataForm.relation.idPersonne1.nom != '' ||
			dataForm.relation.idPersonne1.prenom != '';
		dataForm.relation.idPersonne2.relationProCheck =
			dataForm.relation.idPersonne2.typeRelation != '' ||
			dataForm.relation.idPersonne2.nom != '' ||
			dataForm.relation.idPersonne2.prenom != '';
		dataForm.relation.relationOrganismeCheck =
			dataForm.relation.idOrganisme0.typeRelation != '' ||
			dataForm.relation.idOrganisme0.nomOrganisme != '' ||
			dataForm.relation.idOrganisme1.typeRelation != '' ||
			dataForm.relation.idOrganisme1.nomOrganisme != '' ||
			dataForm.relation.idOrganisme2.typeRelation != '' ||
			dataForm.relation.idOrganisme2.nomOrganisme != '';
		dataForm.relation.idOrganisme1.relationProCheck =
			dataForm.relation.idOrganisme1.typeRelation != '' ||
			dataForm.relation.idOrganisme1.nomOrganisme != '';
		dataForm.relation.idOrganisme2.relationProCheck =
			dataForm.relation.idOrganisme2.typeRelation != '' ||
			dataForm.relation.idOrganisme2.nomOrganisme != '';



		// setup specific perso :

		if (type === Constants.TYPE_FORM.perso) {

			// setup reelNomOuPseudo
			dataForm.reelNomOuPseudo.check =
				dataForm.reelNomOuPseudo.nom != '' ||
				dataForm.reelNomOuPseudo.prenom != '';

			// check and clean Collective/pas Collective dans oeuvre0
			dataForm.oeuvre.idOeuvre0.indOeuvreCollective =
				dataForm.oeuvre.idOeuvre0.titreOeuvreCollective != '';
			dataForm.oeuvre.idOeuvre1.indOeuvreCollective =
				dataForm.oeuvre.idOeuvre1.titreOeuvreCollective != '';
			dataForm.oeuvre.idOeuvre2.indOeuvreCollective =
				dataForm.oeuvre.idOeuvre2.titreOeuvreCollective != '';
			dataForm.oeuvre.idOeuvre3.indOeuvreCollective =
				dataForm.oeuvre.idOeuvre3.titreOeuvreCollective != '';

			return;
		}



		// // setup specific orga :
		//
		// if (type === Constants.TYPE_FORM.orga) {
		//
		// 	return;
		// }
	},
	/**
	 *
	 * @param type
	 * @param dataForm
	 * @description
	 * Clear values of children when the helper data form is = false
	 */
	cleanupHelperDataForm(type, dataForm) {
		// cleanup common to perso and orga :

		// check and clean nomAssocie (0 to 2)
		if (!dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept0.check) {
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept0.associeNom = "";
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept0.associeNomType = "";
		}
		if (!dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept1.check) {
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept1.associeNom = "";
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept1.associeNomType = "";
		}
		if (!dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept2.check) {
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept2.associeNom = "";
			dataForm.donneeIdentification.nomAssocie.idNomAssocieAccept2.associeNomType = "";
		}

		// check and clean variante (0 to 4)
		if (!dataForm.donneeIdentification.variante.idVariante0.check) {
			dataForm.donneeIdentification.variante.idVariante0.nom = "";
			dataForm.donneeIdentification.variante.idVariante0.prenom = "";
		}
		if (!dataForm.donneeIdentification.variante.idVariante1.check) {
			dataForm.donneeIdentification.variante.idVariante1.nom = "";
			dataForm.donneeIdentification.variante.idVariante1.prenom = "";
		}
		if (!dataForm.donneeIdentification.variante.idVariante2.check) {
			dataForm.donneeIdentification.variante.idVariante2.nom = "";
			dataForm.donneeIdentification.variante.idVariante2.prenom = "";
		}
		if (!dataForm.donneeIdentification.variante.idVariante3.check) {
			dataForm.donneeIdentification.variante.idVariante3.nom = "";
			dataForm.donneeIdentification.variante.idVariante3.prenom = "";
		}
		if (!dataForm.donneeIdentification.variante.idVariante4.check) {
			dataForm.donneeIdentification.variante.idVariante4.nom = "";
			dataForm.donneeIdentification.variante.idVariante4.prenom = "";
		}

		// check and clean oeuvre (0 to 3)
		if (!dataForm.oeuvre.idOeuvre1.ajoutCheck) {
			dataForm.oeuvre.idOeuvre1.roleOeuvre = "";
			dataForm.oeuvre.idOeuvre1.sousTitreOeuvre = "";
			dataForm.oeuvre.idOeuvre1.thematiqueOeuvre = "";
			dataForm.oeuvre.idOeuvre1.titreOeuvre = "";
			dataForm.oeuvre.idOeuvre1.typeOeuvre = "";
		}
		if (!dataForm.oeuvre.idOeuvre2.ajoutCheck) {
			dataForm.oeuvre.idOeuvre2.roleOeuvre = "";
			dataForm.oeuvre.idOeuvre2.sousTitreOeuvre = "";
			dataForm.oeuvre.idOeuvre2.thematiqueOeuvre = "";
			dataForm.oeuvre.idOeuvre2.titreOeuvre = "";
			dataForm.oeuvre.idOeuvre2.typeOeuvre = "";
		}
		if (!dataForm.oeuvre.idOeuvre3.ajoutCheck) {
			dataForm.oeuvre.idOeuvre3.roleOeuvre = "";
			dataForm.oeuvre.idOeuvre3.sousTitreOeuvre = "";
			dataForm.oeuvre.idOeuvre3.thematiqueOeuvre = "";
			dataForm.oeuvre.idOeuvre3.titreOeuvre = "";
			dataForm.oeuvre.idOeuvre3.typeOeuvre = "";
		}

		// check and clean relation (0 to 2 Personne, 0 to 2 Organisme)
		if (!dataForm.relation.relationProCheck) {
			dataForm.relation.idPersonne0.typeRelation = "";
			dataForm.relation.idPersonne0.nom = "";
			dataForm.relation.idPersonne0.prenom = "";
			dataForm.relation.idPersonne1.typeRelation = "";
			dataForm.relation.idPersonne1.nom = "";
			dataForm.relation.idPersonne1.prenom = "";
			dataForm.relation.idPersonne2.typeRelation = "";
			dataForm.relation.idPersonne2.nom = "";
			dataForm.relation.idPersonne2.prenom = "";
		} else {
			if (!dataForm.relation.idPersonne1.relationProCheck) {
				dataForm.relation.idPersonne1.typeRelation = "";
				dataForm.relation.idPersonne1.nom = "";
				dataForm.relation.idPersonne1.prenom = "";
			}
			if (!dataForm.relation.idPersonne2.relationProCheck) {
				dataForm.relation.idPersonne2.typeRelation = "";
				dataForm.relation.idPersonne2.nom = "";
				dataForm.relation.idPersonne2.prenom = "";
			}
		}
		if (!dataForm.relation.relationOrganismeCheck) {
			dataForm.relation.idOrganisme0.typeRelation = "";
			dataForm.relation.idOrganisme0.nomOrganisme = "";
			dataForm.relation.idOrganisme1.typeRelation = "";
			dataForm.relation.idOrganisme1.nomOrganisme = "";
			dataForm.relation.idOrganisme2.typeRelation = "";
			dataForm.relation.idOrganisme2.nomOrganisme = "";
		} else {
			if (!dataForm.relation.idOrganisme1.relationProCheck) {
				dataForm.relation.idOrganisme1.typeRelation = "";
				dataForm.relation.idOrganisme1.nomOrganisme = "";
			}
			if (!dataForm.relation.idOrganisme2.relationProCheck) {
				dataForm.relation.idOrganisme2.typeRelation = "";
				dataForm.relation.idOrganisme2.nomOrganisme = "";
			}
		}



		// cleanup specific perso :

		if (type === Constants.TYPE_FORM.perso) {
			// supprimer des espaces supplémentaires
			dataForm.donneeIdentification.lieu.naissance.loCode = dataForm.donneeIdentification.lieu.naissance.loCode.trim();
			dataForm.donneeIdentification.lieu.naissance.ville = dataForm.donneeIdentification.lieu.naissance.ville.trim();
			dataForm.donneeIdentification.lieu.residence.loCode = dataForm.donneeIdentification.lieu.residence.loCode.trim();
			dataForm.donneeIdentification.lieu.residence.ville = dataForm.donneeIdentification.lieu.residence.ville.trim();

			// check and clean instrumentMusic
			if (dataForm.donneeIdentification.domaineActivite !== '_4') {
				dataForm.donneeIdentification.instrumentMusic.length = 0;
			}

			// check and clean reelNomOuPseudo
			if (!dataForm.reelNomOuPseudo.check) {
				dataForm.reelNomOuPseudo.nom = "";
				dataForm.reelNomOuPseudo.prenom = "";
			}

			// check and clean Collective/pas Collective dans oeuvre0
			if (dataForm.oeuvre.idOeuvre0.indOeuvreCollective) {
				dataForm.oeuvre.idOeuvre0.titreOeuvre = "";
				dataForm.oeuvre.idOeuvre0.sousTitreOeuvre = "";
			} else {
				dataForm.oeuvre.idOeuvre0.titreOeuvreCollective = "";
			}

			// check and clean oeuvre (0 to 3)
			// supplementaire cleanup specific fields to PERSO only
			if (!dataForm.oeuvre.idOeuvre1.ajoutCheck) {
				dataForm.oeuvre.idOeuvre1.titreOeuvreCollective = "";
			} else {
				// check and clean Collective/pas Collective dans oeuvre1
				if (dataForm.oeuvre.idOeuvre1.indOeuvreCollective) {
					dataForm.oeuvre.idOeuvre1.titreOeuvre = "";
					dataForm.oeuvre.idOeuvre1.sousTitreOeuvre = "";
				} else {
					dataForm.oeuvre.idOeuvre1.titreOeuvreCollective = "";
				}
			}
			if (!dataForm.oeuvre.idOeuvre2.ajoutCheck) {
				dataForm.oeuvre.idOeuvre2.titreOeuvreCollective = "";
			} else {
				// check and clean Collective/pas Collective dans oeuvre2
				if (dataForm.oeuvre.idOeuvre2.indOeuvreCollective) {
					dataForm.oeuvre.idOeuvre2.titreOeuvre = "";
					dataForm.oeuvre.idOeuvre2.sousTitreOeuvre = "";
				} else {
					dataForm.oeuvre.idOeuvre2.titreOeuvreCollective = "";
				}
			}
			if (!dataForm.oeuvre.idOeuvre3.ajoutCheck) {
				dataForm.oeuvre.idOeuvre3.titreOeuvreCollective = "";
			} else {
				// check and clean Collective/pas Collective dans oeuvre3
				if (dataForm.oeuvre.idOeuvre3.indOeuvreCollective) {
					dataForm.oeuvre.idOeuvre3.titreOeuvre = "";
					dataForm.oeuvre.idOeuvre3.sousTitreOeuvre = "";
				} else {
					dataForm.oeuvre.idOeuvre3.titreOeuvreCollective = "";
				}
			}

			return;
		}



		// cleanup specific orga
		if (type === Constants.TYPE_FORM.orga) {
			// supprimer des espaces supplémentaires
			dataForm.donneeIdentification.lieu.activite.loCode = dataForm.donneeIdentification.lieu.activite.loCode.trim();
			dataForm.donneeIdentification.lieu.activite.ville = dataForm.donneeIdentification.lieu.activite.ville.trim();
			dataForm.donneeIdentification.lieu.siegeSocial.loCode = dataForm.donneeIdentification.lieu.siegeSocial.loCode.trim();
			dataForm.donneeIdentification.lieu.siegeSocial.ville = dataForm.donneeIdentification.lieu.siegeSocial.ville.trim();

			return;
		}
	}
};
